<template>
  <Modal :value="value" @input="closeModal" width="xl">
    <div slot="header">
      {{ header }}
    </div>

    <Show :id="order.id" />
  </Modal>
</template>

<script>
const Show = () => import('@/components/admin/maestro/v3/manager-consults/Show')
import Modal from '@/components/shares/specialTag/Modal'
import DownloadCreator from '@/models/DownloadCreator'

export default {
  components: {
    Modal,
    Show
  },
  computed: {
    header() {
      return this.order.kind
    }
  },
  methods: {
    closeModal() {
      this.$emit('input', false)
    },
    download() {
      const string = JSON.stringify(this.order, null, 2)
      const id = this.order.id ? this.order.id : 'order'
      DownloadCreator.download(`${id}.json`, string)
    },
  },
  name: 'ModalDetail',
  props: {
    value: { default: false, type: Boolean },
    order: { required: true, type: Object },
  },
}
</script>

<style scoped></style>
